export default {
  loadingApp: 'Loading CrewPresence…',
  copied: 'Copied',
  fromDate: 'From date',
  toDate: 'To date',
  lastDays: '{count} days',
  staleHint: 'The last refresh failed. This is the most recent data we have',
  autoRefreshHint: 'Refreshes automatically',
  staleFrom: 'Stale · from {ago}',
  refreshing: 'Refreshing…',
  liveAgo: 'Live · {ago}',
  refreshNow: 'Refresh now',
  pageRange: '<b>{first}-{last}</b> of {total}',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  loading: 'Loading',
  couldNotLoad: "Couldn't load this",
  backToDashboard: 'Back to dashboard',
  rosterAnywayTitle: 'Roster anyway?',
  rosterConflictOne: '{name} is on leave or unavailable then.',
  rosterConflictMany: 'These people are on leave or unavailable then.',
  rosterAnyway: 'Roster anyway',
  pickerSearch: 'Search employees',
  pickerCount: '{count} of {max} chosen',
  pickerNoMatch: 'No employees with an email address match.',
  pickerRemove: 'Remove {name}',
}
